import { useRef } from 'react';

export default function useLowest(value) {
  const lowerRef = useRef(value);

  if (lowerRef.current > value) {
    lowerRef.current = value;
  }

  return lowerRef.current;
}
